import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "thumbnail", "status"]
  static values = { index: Number }

  connect() {
    this.connected = true
    this.loadVersion ||= 0
    this.preloadedImages = new Map([[this.indexValue, this.imageTarget]])
    this.waitForImage()
  }

  disconnect() {
    this.connected = false
    this.loadVersion++
    this.preloadedImages.clear()
  }

  waitForImage() {
    const version = ++this.loadVersion
    this.imageTarget.decode().then(() => {
      if (!this.connected || version !== this.loadVersion) return
      this.element.querySelector("[data-gallery-preview]")?.remove()
      this.preloadNext()
    }, () => {
      // Keep the available preview when the full photo fails to load.
    })
  }

  preloadNext() {
    if (this.thumbnailTargets.length < 2) return
    const nextIndex = (this.indexValue + 1) % this.thumbnailTargets.length
    if (this.preloadedImages.has(nextIndex)) return

    const thumbnail = this.thumbnailTargets[nextIndex]
    const image = new Image()
    image.fetchPriority = "low"
    image.sizes = this.imageTarget.sizes
    image.srcset = thumbnail.dataset.gallerySrcset
    image.src = thumbnail.dataset.galleryUrl
    this.preloadedImages.set(nextIndex, image)
  }

  select({ params: { index } }) {
    this.show(index)
  }

  previous() {
    this.show(this.indexValue - 1)
  }

  next() {
    this.show(this.indexValue + 1)
  }

  show(index) {
    const nextIndex = (Number(index) + this.thumbnailTargets.length) % this.thumbnailTargets.length
    const selectedThumbnail = this.thumbnailTargets[nextIndex]

    this.element.querySelector("[data-gallery-preview]")?.remove()
    this.imageTarget.srcset = selectedThumbnail.dataset.gallerySrcset
    this.imageTarget.src = selectedThumbnail.dataset.galleryUrl
    this.indexValue = nextIndex
    this.preloadedImages.set(nextIndex, this.imageTarget)
    this.statusTarget.textContent = `Fotografie ${nextIndex + 1} z ${this.thumbnailTargets.length}`

    this.thumbnailTargets.forEach((thumbnail, thumbnailIndex) => {
      const selected = thumbnailIndex === nextIndex

      thumbnail.setAttribute("aria-pressed", selected)
      thumbnail.classList.toggle("border-action", selected)
      thumbnail.classList.toggle("border-transparent", !selected)
      thumbnail.classList.toggle("hover:border-warm-border-strong", !selected)
    })
    this.waitForImage()
  }
}
